import { getArea } from '@/apis/shopcart'
import { getAdtList, getAdtTmpl } from '@/apis/addition'
import useCache from './useCache'

// 发货地区
export declare interface A {
  intAreaId: number
  label: string
  children?: A[]
}
export const area: Promise<A[]> = getArea({ type: 0 }).then((res) => res.data)

// 附加项
interface ADT {
  productAdditionList: any
  deliveryAdditionList: any
}
// 普通商品附加项 发货附加项
export const adt: () => Promise<ADT> = useCache(
  () => getAdtList({ productType: 1 }).then((res) => res.data),
  (data: any) => data
)

// 组合商品附加项 组合发货附加项
export const gpAdt: () => Promise<ADT> = useCache(
  () => getAdtList({ productType: 2 }).then((res) => res.data),
  (data: any) => data
)

// 后台已配置的附加项模板
export const adtTmpl: () => Promise<any> = useCache(
  () => getAdtTmpl().then((res) => res.data),
  (data: any) => data
)

// 物流公司
